import { humanizeCalcKind, humanizeName, CALC_KIND_BADGE_COLORS, summaryByKind } from "../../utils/rateConcepts";

export default function ConceptsSummary({ concepts, onEdit, editable }) {
  const active = concepts.filter(c => c.is_active);

  return (
    <section className="card summary-card">
      <header className="summary-header">
        <h3>Conceptos tarifarios</h3>
        {editable && (
          <button
            type="button"
            className="summary-edit"
            onClick={onEdit}
          >
            Editar conceptos
          </button>
        )}
      </header>

      <div className="summary-list">
        {concepts.map(c => (
          <div key={c.id} className="concept-card">
            <div className="concept-card-header">
              <strong>{humanizeName(c.name)}</strong>
              <span
                className={`badge ${CALC_KIND_BADGE_COLORS[c.calc_kind]}`}
              >
                {humanizeCalcKind(c.calc_kind)}
              </span>
            </div>

            <div className="concept-summary">
              {summaryByKind(c)}
            </div>
          </div>
          
        ))}
      </div>

      <small>
        {active.length} conceptos activos
        {active.length !== concepts.length &&
          " (algunos inactivos)"}
      </small>
    </section>
  );
}
